import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconWaiting100pxBoldS = function IconWaiting100pxBoldS(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 100 100",
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_7_1442)",
      children: [/*#__PURE__*/_jsx("circle", {
        cx: "50",
        cy: "50",
        r: "40",
        fill: "#FFBC08"
      }), /*#__PURE__*/_jsx("path", {
        d: "M65.547 46.5c0 9.89-8.157 18-18.331 18-10.175 0-18.331-8.11-18.331-18s8.156-18 18.33-18c10.175 0 18.332 8.11 18.332 18z",
        stroke: "#fff",
        strokeWidth: "7"
      }), /*#__PURE__*/_jsx("path", {
        d: "M63.38 57.506l-2.494-2.456-4.912 4.988 2.494 2.456 4.911-4.988zm5.75 15.488a3.5 3.5 0 104.911-4.988l-4.912 4.988zm-10.662-10.5l10.661 10.5 4.912-4.988-10.661-10.5-4.912 4.988z",
        fill: "#fff"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_7_1442",
        children: /*#__PURE__*/_jsx("rect", {
          width: "100",
          height: "100",
          fill: "#fff"
        })
      })
    })]
  }));
};
export default IconWaiting100pxBoldS;